import { QueryApiService } from 'src/common/api-service';
import { AuditableEntity } from '../common';

export interface IndustryArea extends AuditableEntity<number> {
  name: string;
}

export interface IndustryAreaSearchResultItem {
  id: number;
  label: string;
  score: number;
}

export class IndustryAreaApiService extends QueryApiService<IndustryArea> {
  constructor() {
    super('industryAreas');
  }

  public async search(input: string, size: number = 10): Promise<IndustryAreaSearchResultItem[]> {
    try {
      var result = await this.get<{ count: number; items: IndustryAreaSearchResultItem[] }>('search', { input, size });
      return result?.items ?? [];
    } catch {
      return [];
    }
  }
}
